import useMerchantDocuments from '@/hooks/useMerchantDocuments'
import { TDocumentFormikValuesType, TUploadedFile } from '@/types/uploader'
import { toast } from 'react-toastify'
import { deleteDocument } from '@/api/delete-document/deleteDocuments'

export const useDocumentUploader = (formik: TDocumentFormikValuesType) => {
  const { upload, update } = useMerchantDocuments()

  const handleUpload = async (
    field: keyof typeof formik.values,
    file: File
  ) => {
    const tempFile: TUploadedFile = {
      file,
      title: file.name,
      loading: true
    }

    const current: TUploadedFile[] = Array.isArray(formik.values[field])
      ? (formik.values[field] as TUploadedFile[])
      : []
    formik.setFieldValue(field, [...current, tempFile])

    try {
      const res = await upload(file, field)
      const uploadedFile: TUploadedFile = {
        id: res.document_id,
        file,
        title: file.name,
        loading: false
      }

      const updated = [...formik.values[field]]
      updated.push(uploadedFile)
      formik.setFieldValue(field, updated)
    } catch (err) {
      const updated = [...(formik.values[field] ?? [])]
      formik.setFieldValue(field, updated)
    }
  }

  const handleReplace = async (
    field: keyof typeof formik.values,
    file: File,
    documentId?: number
  ) => {
    const current: TUploadedFile[] =
      (formik.values[field] as TUploadedFile[]) ?? []
    const existingId =
      documentId ?? current.find((uploadedFile) => uploadedFile.id)?.id

    if (!existingId) {
      return
    }

    formik.setFieldValue(field, [
      {
        id: existingId,
        file: file,
        title: file.name,
        loading: true
      }
    ])

    try {
      const res = await update(existingId, file, field)
      formik.setFieldValue(field, [
        {
          id: res?.document_id ?? existingId,
          file: file,
          title: file.name,
          loading: false
        }
      ])
    } catch (err) {
      formik.setFieldValue(field, [{ id: existingId }])
    }
  }

  const handleDelete = async (
    field: keyof typeof formik.values,
    uploadedFile: TUploadedFile
  ) => {
    const current: TUploadedFile[] = Array.isArray(formik.values[field])
      ? (formik.values[field] as TUploadedFile[])
      : []
    const file = current.filter((f) => f.id === uploadedFile.id).at(0)

    if (file?.id) {
      deleteDocument(file.id)
        .then(() => {
          formik.setFieldValue(field, [
            ...current.filter((f) => f.id !== uploadedFile.id)
          ])
          toast.success('فایل با موفقیت حذف شد')
        })
        .catch(() => {})
    }
  }

  return { handleUpload, handleReplace, handleDelete }
}
